import { NotificationsResponse } from "../../../../components/notification/notifications.types";
import { useVeriModel, UseVeriModelOptions } from "../../useVeriModel";
import apiNotificationsModel from "./apiNotificationsModel";

export function useNotificationsModel(
  opts?: UseVeriModelOptions<NotificationsResponse>,
) {
  return useVeriModel(apiNotificationsModel, opts);
}
